import PropTypes from 'prop-types';

export const ProductDefaultProps = {
  addToCartOptions: null,
  className: null,
  disabled: false,
  imageSize: null,
  isLoading: false,
  product: {},
  sortables: {},
  tableRowSize: 'large',
  type: null,
};

export const ProductPropTypes = {
  addToCartOptions: PropTypes.shape({
    dataLayer: PropTypes.shape({
      event: PropTypes.string,
    }),
    flashMessage: PropTypes.bool,
    link: PropTypes.bool,
    linkUrl: PropTypes.string,
    messages: PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      undo: PropTypes.string,
    }),
    modal: PropTypes.bool,
    predictions: PropTypes.bool,
    undo: PropTypes.bool,
  }),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  imageSize: PropTypes.string,
  isLoading: PropTypes.bool,
  product: PropTypes.shape({
    brand: PropTypes.shape({}),
    configurations: PropTypes.arrayOf(PropTypes.shape({})),
    configurator: PropTypes.shape({
      id: PropTypes.string,
      num_configurations: PropTypes.number,
    }),
    favorite: PropTypes.bool,
    flags: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string,
    image: PropTypes.shape({}),
    main_sku: PropTypes.string,
    manufacturer_sku: PropTypes.string,
    name: PropTypes.string,
    path: PropTypes.string,
    price_and_stock: PropTypes.shape({
      has_price: PropTypes.bool,
      has_stock: PropTypes.bool,
      invoice_unit: PropTypes.string,
      price: PropTypes.shape({
        customer_price: PropTypes.number,
        public_price: PropTypes.number,
        discount_price: PropTypes.number,
        discount_classes: PropTypes.arrayOf(PropTypes.string),
        tier_prices: PropTypes.arrayOf(PropTypes.shape({})),
        weee_amount: PropTypes.number,
        invoice: PropTypes.shape({
          unit: PropTypes.string,
          public_price: PropTypes.number,
          customer_price: PropTypes.number,
          discount_price: PropTypes.number,
          weee_amount: PropTypes.number,
        }),
        sale: PropTypes.shape({
          unit: PropTypes.string,
          public_price: PropTypes.number,
          customer_price: PropTypes.number,
          discount_price: PropTypes.number,
          weee_amount: PropTypes.number,
        }),
      }),
      sale_unit: PropTypes.string,
      stock_status: PropTypes.string,
      stocks: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    sales_packaging: PropTypes.number,
    sku: PropTypes.string,
    slug: PropTypes.string,
    sortables: PropTypes.oneOfType([
      PropTypes.shape({
        [PropTypes.string]: PropTypes.shape({
          code: PropTypes.string,
          displayable: PropTypes.bool,
          filterable: PropTypes.bool,
          label: PropTypes.string,
          order: PropTypes.number,
          searchable: PropTypes.bool,
          sortable: PropTypes.bool,
          unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }),
      }),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    split_packaging: PropTypes.bool,
  }),
  sortables: PropTypes.oneOfType([
    PropTypes.shape({
      [PropTypes.string]: PropTypes.shape({
        code: PropTypes.string,
        displayable: PropTypes.bool,
        filterable: PropTypes.bool,
        label: PropTypes.string,
        order: PropTypes.number,
        searchable: PropTypes.bool,
        sortable: PropTypes.bool,
        unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    }),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  tableRowSize: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.string,
};
